module.exports = __webpack_public_path__ + "media/61.c1fea5f2.mp3";